// Bookable services per home-services branch, built from the ad's own fields (ids/labels stored on the booking).
const aed = (n, ar) => (ar ? `${Number(n).toLocaleString("en")} درهم` : `AED ${Number(n).toLocaleString("en")}`);

export function bookingServices(meta, listing, lang) {
  const ar = lang !== "en";
  const L = (o) => (o ? (ar ? o.ar : o.en) : "");
  const f = listing.fields || {};
  const defs = meta?.subcat_fields?.[listing.subcategory] || [];
  const offers = listing.dw_offers || {};
  const U = meta?.unknown_value;
  const out = [];
  let curGroup = "";
  // group + kind drive the one-option-per-group rule: "single" (many allowed) vs "all" / "exclusive" (alone).
  const add = (id, label, price, offerKey, group = null, kind = "single") => {
    const o = offerKey && offers[offerKey];
    out.push({ id, label, price: o ? o.price : Number(price) > 0 ? Number(price) : null, original: o ? o.original : null, group, kind, groupLabel: curGroup });
  };
  const PET = { cat_services: ["cat", "cat_count_pricing", "cat_count_note", "قط", "cat"], dog_services: ["dog", "dog_count_pricing", "dog_count_note", "كلب", "dog"],
    other_animal_services: ["other", "other_count_pricing", "other_count_note", "حيوان", "pet"] };
  const has = (k, id) => String(f[k] || "").split(",").includes(id);
  defs.forEach((d) => {
    const v = f[d.key];
    if (d.type === "priced_services" && v?.selected?.length && listing.subcategory !== "movers") {
      if (d.showIf && !has(d.showIf.key, d.showIf.equals)) return;
      const group = listing.subcategory === "car_wash" ? `${L(d).split(":")[0]}: ` : listing.subcategory === "pet_care" ? `${{ cat_services: ar ? "القطط" : "Cats", dog_services: ar ? "الكلاب" : "Dogs" }[d.key] || (ar ? "حيوانات أخرى" : "Other animals")}: ` : "";
      const pfx = d.key.startsWith("services_") ? `${d.key.slice(9)}_` : "";
      curGroup = group.replace(/:\s*$/, "");
      const pet = PET[d.key];
      const allOk = ["all", "both"].includes(v.mode) && Number(v.all_price) > 0;
      if (!(v.mode === "all" && allOk)) v.selected.forEach((id) => {
        const name = id === "other" && v.other_text ? v.other_text : L(d.options?.find((o) => o.id === id)) || (id === "other" ? (ar ? "أخرى" : "Other") : id);
        add(`${d.key}:${id}`, group + name, v.mode === "all" ? null : v.prices?.[id], listing.subcategory === "laundry" ? id : pfx ? pfx + id : null, d.key);
      });
      if (allOk) add(`${d.key}:all`, group + (d.allLabel ? L(d.allLabel) : ar ? "سعر جميع الخدمات" : "Price of all services"), v.all_price, pet ? `${pet[0]}_all` : pfx ? `${pfx}all` : null, d.key, "all");
      const t = pet && String(f[pet[1]] || "").split(",").includes("by_count") && f[pet[2]];
      if (t && typeof t === "object" && t.min_count && Number(t.price) > 0) {
        add(`${d.key}:exclusive`, `${group}${ar ? `🌟 عرض حصري — ${t.min_count} ${pet[3]} فأكثر` : `🌟 Exclusive offer — ${t.min_count} ${pet[4]}s or more`}`, t.price, null, d.key, "exclusive");
      }
    }
  });
  curGroup = "";
  if (listing.subcategory === "cleaning_company") {
    if (has("housing_types", "villa")) add("villa", ar ? "تنظيف فيلا" : "Villa cleaning", f.villa_price !== U ? f.villa_price : null, "villa");
    if (has("housing_types", "apartment")) add("apartment", ar ? "تنظيف شقة" : "Apartment cleaning", f.apartment_price !== U ? f.apartment_price : null, "apartment");
  }
  if (listing.subcategory === "cleaning_daily") {
    add("hourly", ar ? "عامل بالساعة" : "Worker per hour", f.hourly_rate !== U ? f.hourly_rate : null);
    if (has("package_mode", "hours") && f.package_hours) add("package_hours", ar ? `عرض ${f.package_hours} ساعات` : `${f.package_hours}-hour offer`, f.package_price);
    if (has("package_mode", "full_day")) add("package_day", ar ? "عرض يوم كامل" : "Full-day offer", f.package_day_price);
  }
  if (listing.subcategory === "movers") {
    const d = defs.find((x) => x.key === "services");
    const v = f.services;
    if (v?.selected?.length) {
      v.selected.forEach((id) => add(`services:${id}`, L(d?.options?.find((o) => o.id === id)) || id, f.price_mode === "fixed" ? v.prices?.[id] : null, `svc_${id}`, "services"));
      if (v.mode === "both" && Number(v.all_price) > 0) add("services:all", ar ? "الخدمتان معاً (سعر موحد)" : "Both services (combined price)", v.all_price, "svc_all", "services", "all");
    } else {
      const names = { move_pack: ar ? "نقل الأثاث وتغليفه" : "Furniture moving & packing", assembly: ar ? "فك وتركيب الأثاث" : "Furniture disassembly & assembly" };
      String(f.service_type || "").split(",").filter(Boolean).forEach((id) => add(id, names[id] || id, f.price_mode === "fixed" ? listing.original_price || listing.price : null));
    }
  }
  return out.map((s) => ({ ...s, priceText: s.price ? aed(s.price, ar) : ar ? "السعر عند الاتصال" : "Price on call", originalText: s.original ? aed(s.original, ar) : null }));
}
